import FilterAttributeMethodsTypes from '@ve/components/filters/common/filterMethods/filterAttributeMethodsHotelArray/FilterAttributeMethodsHotelArray';
import restTypeData from './restTypeData';
import { IRestType } from '../types';

const filterAttributeMethodsRestType = new FilterAttributeMethodsTypes<IRestType>(restTypeData, 'restType').setFilterName('Тип отдыха');

export default filterAttributeMethodsRestType;
